import React from 'react';

import { connect } from 'react-redux';

import BobConfirmButton from './../../../components/BobConfirmButton';

import * as classes from '../CreateEntityPage.module.css';

const CompanyMetrics = ({
    companyMetrics,
    handleBackClick,
    ...props
}) => {

    const handleRoute = () => {
        handleBackClick();
    };

    return (
        <div className={classes.companyForm}>
            <div className={classes.companyDetailsHeaderRow}>
                Company Metrics
            </div>
            <div className={classes.companySettingsHeaderRow} />
            <div className={classes.companyDetailsPanel}>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Bas Agent Count
                    </div>
                    <div>
                        {companyMetrics.numAgents || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Device Count
                    </div>
                    <div>
                        {companyMetrics.numDevices || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Device Object Count
                    </div>
                    <div>
                        {companyMetrics.numDeviceObjects || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Site Count
                    </div>
                    <div>
                        {companyMetrics.numSites || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        System Count
                    </div>
                    <div>
                        {companyMetrics.numSystems || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Equipment Count
                    </div>
                    <div>
                        {companyMetrics.numEquipments || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Sensor Count
                    </div>
                    <div>
                        {companyMetrics.numSensors || 0}
                    </div>
                </div>
                <div className={classes.MetricItem}>
                    <div className={classes.MetricLabel}>
                        Billable Sites
                    </div>
                    <div>
                        {companyMetrics.numBillableSites || 0}
                    </div>
                </div>
            </div>
            <div className={classes.companySettingsPanel} />
            <div className={classes.companyButtonsPanel}>
                <BobConfirmButton
                    onClick={() => handleRoute()}
                    className={classes.ButtonWithMargin}
                    label={'Cancel'}
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        companyMetrics: state.companyManagement.companyMetrics
    };
};

export default connect(mapStateToProps, null)(CompanyMetrics);
